<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs
          headline="Danh sách lớp bán trú"
          :link="[
            {
              text: 'Lớp bán trú',
              href: '../boarding-class',
            },
          ]"
        />
      </div>
      <div class="flex-center">
        <v-btn depressed dark color="primary" @click="() => $refs['popup-create'].openDialog()">
          Thêm lớp bán trú mới
        </v-btn>
      </div>
    </div>

    <v-card outlined class="pa-6 mx-4 mb-6 elevation-0">
      <BoardingClassFilter @onFilterChanged="refresh" />
    </v-card>

    <v-card outlined class="mx-4 elevation-0">
      <DayBoardingDataTable ref="table" />
    </v-card>
    <PopupCreate ref="popup-create" />
  </div>
</template>

<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import BoardingClassFilter from './Filter.vue'
import DayBoardingDataTable from './Table.vue'
import PopupCreate from './PopupCreate.vue'

export default {
  components: {
    Breadcrumbs,
    BoardingClassFilter,
    DayBoardingDataTable,
    PopupCreate,
  },
  methods: {
    async refresh(query) {
      this.$refs.table.refresh(query)
    },
  },
}
</script>
